import { IUser } from "src/Interface"

export const validEmail = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/;
export const validPassword = /.{12,}$/
export const validString = /^.{2,32}$/


export const handleValidation = (regexp: RegExp, fieldName: string, setErrors: (err) => void, errors: any) => (value: string): void => {
  let error = false

  if (value && regexp && !regexp.test(value || '')) {
    error = true
  }
  setErrors({
    ...errors,
    [fieldName]: error
  })
}

export const resetError = (fieldName: string, setErrors: (err) => void, errors: any, resetCredentials?: (boolean: boolean) => void): void => {
  if (resetCredentials) {
    resetCredentials(false)
  }
  setErrors({
    ...errors,
    [fieldName]: false
  })
}

export const handleInputChange: (fieldName: string, setValues: (val) => void, values: any) => void = (fieldName, setValues, values) => (value: string) => {
  setValues({
    ...values,
    [fieldName]: value
  })
}

export const isHigherRole = (userA: IUser, userB: IUser): boolean => {
  if (userA.role === 'DanTaxiAdmin') {
    return true
  } else if (userA.role === 'CompanyAdmin') {
    if (userB.role !== 'DanTaxiAdmin' && userB.role !== 'CompanyAdmin') {
      return true
    } else {
      return false
    }
  } else if (userA.role === 'BranchAdmin') {
    if (userB.role === 'BranchEmployee') {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export const baseApiURL = (): string => process.env.API_URL ?? '';
export const baseApiSocketURL = (): string => process.env.SOCKET_URL ?? '';

export const releaseDetail = {
  version: "v1.0.3"
}